import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var CheckFillSmall = function CheckFillSmall(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#4C5165' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.6rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Info icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 16 16",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M14 4L6.91058 11.9284L2.52588 8.35101",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export default CheckFillSmall;